import axios from 'axios';
import { Auth } from "aws-amplify";
import { API_GATEWAY_BASE_URL, USE_AUTH0, DEPLOYMENT_REGION } from "../utils/constants";

export const setCookieForTunnel = async (sourceToken, region) => {
    try {
        let authToken = '';
        if (USE_AUTH0) {
            if (window.getAuth0Token) {
                authToken = await window.getAuth0Token();
            }
        } else if (DEPLOYMENT_REGION === "USA") {
            const session = await Auth.currentSession();
            authToken = session.getIdToken().getJwtToken();
        } else {
            authToken = localStorage.getItem("keycloakToken") || '';
        }

        let userName = '';
        if (USE_AUTH0) {
            userName = localStorage.getItem("auth0Username") || '';
        } else if (DEPLOYMENT_REGION === "USA") {
            const user = await Auth.currentAuthenticatedUser();
            userName = user?.attributes?.email?.split("@")[0] || '';
        } else {
            userName = localStorage.getItem("keycloakUsername") || '';
        }
        
        const response = await axios.post(
            `${API_GATEWAY_BASE_URL}/tunnel/set-cookie`,
            { 
                token: sourceToken,
                region: region,
                userName: userName
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${authToken}`
                },
                withCredentials: true
            }
        );
        
        return response.data;
    } catch (err) {
        console.error('Failed to set cookie for tunnel:', err);
        throw err;
    }
};
